<template>
        <h1>Product_Data</h1>
        <div class="p__container">
            <div class="p__grid grid grid-cols-[repeat(auto-fill,minmax(300px,1fr))] gap-4">
                <div v-for="productdata in products" :key="productdata.product_id">
                <div class="card card-body w-full h-full border p-4 rounded-lg shadow-sm bg-white flex flex-col">
            
                    <img :style="{display: 'block', margin: '0 auto 10px', maxHeight: '200px'}" class="img-fluid object-contain w-full" :src="productdata.product_img" :alt="productdata.product_name" />
                    
                    <div class="flex justify-between items-center mb-4">
                                    
                            <p  class="text-start font-medium">{{productdata.product_name}}</p> 

                            <p  class="text-end font-bold">${{productdata.product_price}}</p>

                    </div>
                    
                    <div class="flex justify-end mt-auto">
                            <Button  label="Add To Cart" class="p-button-outlined" @click="addProdutToStorage(productdata)"> Add To Cart</Button>
                    </div>
                </div>
                </div>
            </div>
                        
        </div>
</template>

<script>
//import api from '../utils/axios';
import Button from "primevue/button";
import { useUserCartStore } from '../store/storecart';
import { ProductService } from '../service/productservice';
export default {
    name: 'ProductData',
    components: {
        Button,
    },
    data() {
        return {
            // 建議命名為複數，且初始化為陣列（如果是多筆資料）
            products: [], 
        }; 
    },
    // 修正 1：屬性名必須是 methods (複數)，不是 method
    methods: {
        async getProducts() {
            console.log('product 45');
            try {
                // 修正 2：必須使用 await，否則拿到的只是 Promise 物件
                console.log('product 56');
                //const response = await api.get('/product');
                const getdata = ProductService.getProductData();
                this.products = getdata;
                //console.error.log(this.products);
                //console.log(getdata);
                
                // 修正 3：axios 的資料在 .data 屬性中
                //this.products = response.data; 
                //console.log(this.products);
                //console.log('獲取產品成功:', this.products);
            } catch (error) {
                console.error('獲取產品失敗:', error);
            }
        },
        addProdutToStorage(item) {
            const store = useUserCartStore();
            console.log('加入購物車的產品:', item);
            store.addcart(item);
            // 實作你的儲存邏輯 (例如存到 localStorage 或 Pinia)
        }
    },
    // 修正 4：使用生命週期鉤子自動執行
    mounted() {
        console.log('組件已掛載，開始獲取資料...');
        this.getProducts(); // 自動執行
    }
}
</script>
